import axios from "axios";
import { apiRPTUrl } from "./constants";

import router from "@/router"
import store from "@/store"

// ===================
// =     CONFIG      =
// ===================

const _axios = axios.create({ baseURL: apiRPTUrl });

// _axios.interceptors.request.use(async (config) => {
//     config.url = `${apiRPTUrl}/${config.url}`;
//     return config;
// });

_axios.interceptors.response.use(response => {
    return response;
}, async (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        const { renewToken } = require("./user").default;
        renewToken();
        // if (!await renewToken()) {
        //     router.push("/login");
        //     store.dispatch("Logout");
        //     store.dispatch({ type: 'MakeAlert', msg: 'Session timeout or Authen error', color: 'secondary' });
        // }
        return { data: { success: false, msg: "Please try again", jwtexpire: 1 } };
    }
    // error shoud be interpret by api not while using func
    return { data: null, status: error.response && error.response.status }; // {data: {success: 0, status: error.response && error.response.status}};
});

_axios.defaults.withCredentials = true;

export default _axios;